var validationMixin = {

	computed: {
		isValid() {
			return true;
		}
	},

	watch: {
		isValid: function (newValid, oldValid) {
			this.validate();
		}
	},

	methods: {
		validate() {
			if (!this.bottom_navigation_rules) return;
			this.bottom_navigation_rules.can_go_next = this.isValid;
		}
	},
	mounted() {
		this.validate();
	}

};

export { validationMixin };
